// @flow

import { SET_IS_FETCHING_NOTIFICATIONS, UNSET_IS_FETCHING_NOTIFICATIONS } from './actionTypes';

export function setIsFetchingNotifications(): TrovitAction {
  return {
    type: SET_IS_FETCHING_NOTIFICATIONS,
  };
}

export function unsetIsFetchingNotifications(): TrovitAction {
  return {
    type: UNSET_IS_FETCHING_NOTIFICATIONS,
  };
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/LoaderNotifications/actions.js